<template>
  <div class="preview-dialog">
    <el-dialog
      :title="$t('lcd.material.previewObj.title')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="cont">
        <div class="imgWrap">
          <video
            controls
            autoplay
            v-if="previewObj.format == 'mp4'"
            :src="previewObj.originalUrl"
          ></video>
          <el-image
            :src="previewObj.originalUrl"
            class="materialImage"
            fit="contain"
            v-else
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div class="imgInfo">
          <el-descriptions
            size="medium"
            :column="1"
            :title="$t('lcd.material.Material Info')"
          >
            <el-descriptions-item :label="$t('lcd.material.Material Name')">{{
              previewObj.materialName
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('lcd.Template.Template No')">{{
              previewObj.materialId
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('images.Material Size')">{{
              previewObj.size
            }}</el-descriptions-item>

            <el-descriptions-item
              :label="$t('lcd.material.Audit State')"
              v-if="previewObj.state != '1'"
            >
              <el-tag size="small" type="danger">{{
                previewObj.stateDesc
              }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('lcd.Template.Resolution')">{{
              previewObj.pixels
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('lcd.material.Format')">
              <el-tag size="small" type="success">{{
                previewObj.format
              }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$t('lcd.material.Duration')"
              v-if="previewObj.format == 'mp4'"
              >{{ previewObj.duration }}</el-descriptions-item
            >
            <el-descriptions-item :label="$t('lcd.Template.Create Time')">{{
              previewObj.updateTime
            }}</el-descriptions-item>
          </el-descriptions>
          <span v-show="false">{{istagList}}</span>
          <div v-if="isEditTag" style="text-align: left;">
            <span>{{$t('images.Tags')}}:  </span>
            <el-tag
              size="small"
              type="succes"
              :disable-transitions="false"
              closable
              v-for="tag in pageTagList"
              :key="tag"
              @close="handleTagClose(tag)"
              style="margin-right: 8px;margin-bottom: 5px;"
              >{{ tag }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="mini"
              max-length="10"
              style="margin-left: 8px"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="mini"
              @click="showInput"
              >+</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateImage } from "@/libs/api/lcd";

export default {
  name: "ConfirmDialog",
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      userData: JSON.parse(localStorage.getItem("userData")),
      pageTagList: []
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
    },
    previewObj: {
      type: Object,
      default: null,
    },
  },
  computed: {
    istagList() {
      console.log('tagList')
      const tags = this.previewObj.tag
        ? this.previewObj.tag.split(",")
        : [this.previewObj.materialName];

        console.log(tags,'TomatoT')
      this.pageTagList = tags
      
      return tags;
    },
    isEditTag() {
      let isEdit = false;
      if (this.previewObj.openType == 3 && this.userData.userRoleId == 1) {
        isEdit = true;
      }
      if (this.previewObj.openType != 3 && this.userData.userRoleId != 1) {
        isEdit = true;
      }
      return isEdit;
    },
  },

  methods: {
    handleClose(val) {
      this.$emit("handleClose", val);
    },

    // 标签相关方法
    handleTagClose(tag) {
      this.pageTagList.splice(this.pageTagList.indexOf(tag), 1);
      this.updataMaterial();
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.pageTagList.push(inputValue);
        this.updataMaterial();
      }
      this.inputVisible = false;
      this.inputValue = "";
    },

    // updataMaterial
    updataMaterial() {
      const params = {
        ...this.previewObj,
        tag: this.pageTagList.join(","),
      };
      updateImage(params).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.preview-dialog ::v-deep {
  color: #35b871;
  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-dialog {
    height: 600px;
    border-radius: 6px;
    width: 1000px;
    margin-top: 0 !important;
    margin: 0 !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
  .cont {
    width: 100%;
    text-align: center;
    height: 510px;
    .imgWrap {
      width: 600px;
      height: 490px;
      position: relative;
      background-color: #f5f5f5;
      border-radius: 4px;
      float: left;
      .materialImage,
      video {
        display: block;
        margin: 0 auto;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .imgInfo {
      width: 330px;
      float: right;
    }

    .icon {
      display: flex;
      justify-content: center;
      color: #ff9600;
    }
    ::v-deep .el-icon-warning-outline {
      font-size: 46px;
    }
    .text {
      margin-top: 16px;
      display: inline-block;
      // color: #FF9600;
    }
  }
  .cancel,
  .confirm {
    cursor: pointer;
    width: 50%;
    position: absolute;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #e6e6e6;
    vertical-align: center;
  }
  .cancel {
    border-right: 1px solid #e6e6e6;
    left: 0;
    color: #333333;
  }
  .confirm {
    right: 0;
    color: #35b871;
  }
}
</style>